var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"theChart",staticClass:"echarts1"},[_vm._v(_vm._s(_vm.list))])
}
var staticRenderFns = []

export { render, staticRenderFns }